module.exports = __webpack_public_path__ + "static/media/me3.7d000720.png";